/*
 * @Author: your name
 * @Date: 2021-12-16 15:02:29
 * @LastEditTime: 2022-04-29 17:03:36
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \sz2\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import $ from 'jquery'
import moment from 'moment'
import Video from 'video.js'
// import 'videojs-contrib-hls'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Video;

Vue.prototype.$moment = moment; //赋值使用
moment.locale('zh-cn'); //需要汉化
Vue.use(ElementUI);
Vue.prototype.$ = $;
Vue.prototype.$axios = axios;

import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  error: require('./assets/images/default.jpg'),
  loading: require('./assets/images/loading.gif'),
  attempt: 1
})


Vue.config.productionTip = false
let token = localStorage.getItem("sz_token");
if (!token) {
  alert("未登录错误，请前往省平台登录！")
  window.location = "https://gbpx.gd.gov.cn/gdceportal/index.aspx"
}
// 路由拦截
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) { // 判断该路由是否需要登陆权限
    var token = localStorage.getItem("sz_token");
    if (token) {
      next();
    } else {
      next({
        path: '/'
      });
    }
  } else {
    next();
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js



// WEBPACK FOOTER //
// ./src/main.js